import { rgba } from 'polished';

// Base
export const blackColor = '#373e44';
export const blueColor = '#307fe2';
export const greenColor = '#35b840';
export const yellowColor = '#fabb09';
export const orangeColor = '#f67828';
export const redColor = '#db3737';
export const purpleColor = '#b440d6';
export const whiteColor = '#fff';

// Greys, based on black color
export const alphaGreyColor = '#7b7f83'; // 34%
export const bravoGreyColor = '#a8abae'; // 57%
export const charlieGreyColor = '#b6b9bb'; // 64%
export const deltaGreyColor = '#c3c5c7'; // 70%
export const echoGreyColor = '#d4d6d7'; // 79%
export const foxtrotGreyColor = '#e5e6e6'; // 87%
export const golfGreyColor = '#f0f1f1'; // 93%
export const hotelGreyColor = '#f7f7f7'; // 96%

// Greys, based on white color
export const white10Color = rgba(whiteColor, 0.1);
export const white20Color = rgba(whiteColor, 0.2);
export const white60Color = rgba(whiteColor, 0.6);
export const white70Color = rgba(whiteColor, 0.7);
export const white80Color = rgba(whiteColor, 0.8);

// dark mode - TODO - replace color names
export const dark333Color = '#333333';
export const dark999Color = '#999999';
export const darkadaColor = '#adadad';
export const darka8aColor = '#a8abae';
export const dark3c3Color = '#3c3c3c';
export const dark474Color = '#474747';
export const darkcccColor = '#cccccc';
export const darkd6dColor = '#d6d6d6';
export const darkc2cColor = '#c2c2c2';

export const separatorColor = foxtrotGreyColor;

// Avatars colors
export const avatarBlue = '#7fa6b3';
export const avatarOrange = '#d59247';
export const avatarPurple = '#9e79ac';
export const avatarGreen = '#7fa835';
export const avatarRed = '#c15a5a';
export const avatarGrey = '$bravo-grey-color';
export const avatarCyan = '#71bbbb';
export const avatarGold = '#e2c62a';
export const avatarOlive = '#b0b032';
export const avatarFabulous = '#3f62aa';
export const avatarHot = '#ff0000';
export const avatarFierce = '#ff661a';
export const avatarCosmic = '#8f2d8e';
export const avatarZen = '#026664';
export const avatarStrong = '#282561';
export const avatarSuper = '#62cc6f';
export const avatarMagic = '#e7ae98';
export const avatarPeaceful = '#b1b6e5';
export const avatarDaring = '#701b2e';
export const avatarHeroic = '#ff0bd1';
export const avatarWise = '#b737b1';
export const avatarFresh = '#fbcb14';
export const avatarPowerful = '#0025ff';
export const avatarSlick = '#bf5253';
export const avatarsColorsList = `blue ${avatarBlue}, orange ${avatarOrange}, purple ${avatarPurple},
  green ${avatarGreen}, red ${avatarRed}, grey ${avatarGrey}, cyan ${avatarCyan}, gold ${avatarGold},
  olive ${avatarOlive}, fabulous ${avatarFabulous}, hot ${avatarHot}, fierce ${avatarFierce},
  cosmic ${avatarCosmic}, zen ${avatarZen}, strong ${avatarStrong}, super ${avatarSuper},
  magic ${avatarMagic}, peaceful ${avatarPeaceful}, daring ${avatarDaring}, heroic ${avatarHeroic},
  wise ${avatarWise}, fresh ${avatarFresh}, powerful ${avatarPowerful}, slick ${avatarSlick}`;

// Brands colors
export const facebookColor = '#3b5998';
export const twitterColor = '#55acee';
export const googleColor = '#dd4b39';

// Backward compatibility
export const grey1Color = '#7b7f83'; // 34%
export const grey2Color = '#a8abae'; // 57%
export const grey3Color = '#c3c5c7'; // 70%
export const grey4Color = '#e5e6e6'; // 87%
export const grey5Color = '#f0f1f1'; // 93%
export const grey6Color = '#f7f7f7'; // 96%
export const blueGreyDarkColor = grey1Color; // old -> #97a5ac
export const blueGreyColor = grey2Color; // old -> #b3bec3
export const blueGreyLightColor = grey3Color; // old -> #d3dbde
export const uiGreyDarkColor = grey4Color; // old -> #d7d7d7
export const uiGreyColor = grey5Color; // old -> #e7e7e7
export const uiGreyLightColor = grey6Color; // old -> #f2f2f3
